import styled, { keyframes } from "styled-components";


const rotate = () => keyframes` 
0% { transform:   rotatez(0)  } 
100% { transform: rotatez(360deg) } `;

export const IndexIntegrationComponentMainDiv = styled.section`

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 100px 40px;
    gap: 60px;
    width: 100%;
  }
  .integration-header-container {
    display: flex;
    gap: 16px;
    flex-direction: column;
    align-items: center;
  }
  .integration-header-text-container {
    max-width: 736px;
    text-align: center;
    > h2 {
      font-size: 65px;
      line-height: 1.2em;
      font-weight: 500;
    }
  }
  .integration-header {
    display: flex;
    gap: 24px;
    flex-direction: column;
  }
  .integration-container {
    max-width: 1140px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 40px;
    position: relative;
    perspective: 1200px;
  }
  .intergration-button-container {
    display: flex;
    min-width: 160px;
  }
  .intergration-background-image {
    position: absolute;
    height: 400px;
    width:  400px;
    border-radius: 100%;
    top:30%;
    bottom:0%;
    transform:translateY(-60%);
    overflow:hidden;
    background: red;
    animation:${rotate} 10s linear infinite;
  }
`;

const marqueeScroll = (distance: number) => keyframes` 
0% { transform: translateX(0px); } 
100% { transform: translateX(${distance}px); } `;


interface IndexIntegrationComponentAppSectionProp {
  length: number;
  itemwidth: number;
  gap: number;
  reverse?: boolean;
}
export const IndexIntegrationComponentAppSection = styled.div<IndexIntegrationComponentAppSectionProp>`
  .integration-app-section-container {
    flex-flow: row;
    align-items: center;
    gap: 0;
    width: 100%;
    margin: 0 auto;
    max-width: 1200px;
    height: min-content;
    display: flex;
    position: relative;
    overflow: visible;
    > div {
      display: flex;
      width: 100%;
      flex: 1;
    }
  }

  .integration-app-section-holder {
    flex-flow: column;
    flex: 1 0 0;
    place-content: center;
    align-items: center;
    gap: 32px;
    width: 1px;
    max-width: 1140px;
    height: min-content;

    padding: 0;
    display: flex;
    position: relative;
    overflow: hidden;
    > div {
      display: flex;
      width: 100%;
      flex: 1;
    }
  }
  .trusted-section-marque-container {
    width: 100%;
    cursor: pointer;
    position:relative > div {
      flex-flow: row;
      place-content: center;
      align-items: center;
      gap: 0;
      width: 100%;
      height: min-content;
      padding: 0;
      display: flex;
      position: relative;
      overflow: visible;
    }
    .trusted-section-marque-gradient-cover {
      width: 60px;
      position: absolute;
      top: 0;
      z-index: 1;
      bottom: 0;
    }
    .trusted-section-marque-gradient-cover-left {
      left: 0;
      background: linear-gradient(
        90deg,
        rgb(0, 0, 0) 0%,
        rgba(0, 0, 0, 0) 100%
      );
    }
    .trusted-section-marque-gradient-cover-right {
      right: 0;
      background: linear-gradient(
        270deg,
        rgb(0, 0, 0) 0%,
        rgba(0, 0, 0, 0) 100%
      );
    }

    .trusted-section-marque-scroll-holder {
      flex: 1 0 0;
      width: 1px;
      height: min-content;
      position: relative;
      padding: 4px > section {
        display: flex;
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
        place-items: center;
        margin: 0px;
        padding: 0px;
        list-style-type: none;
        opacity: 1;
        overflow: hidden;
      }
    }
    .trusted-section-marque-scroll-list {
      list-style-type: none;
      display: flex;
      width: 100%;
      height: 100%;
      max-width: 100%;
      max-height: 100%;
      align-items: center;
      margin: 0px;
      padding: 0px;
      gap: 60px;
      position: relative;
      flex-direction: row;
      justify-content: ${(p) => (p.reverse ? "flex-end" : "flex-start")};
      transform: translateX(
        ${(p) =>
          (p.gap * p.length + p.itemwidth * p.length) * (p.reverse ? 1 : -1)}px
      );
      animation: ${({ gap, length, itemwidth, reverse }) =>
          marqueeScroll(
            (gap * length + itemwidth * length) * (reverse ? 1 : -1),
          )}
        8s linear infinite;
      &:hover {
        animation-play-state: paused;
      }
    }
  }

`;

export const IndexIntegrationComponentAppItesmDiv = styled.li`
  flex-shrink: 0;

  > div {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    backdrop-filter: blur(10px);
    height: 72px;
    width: 72px;
    background: #ffffff05;
    border-radius: 14px;
    border: 1px solid #ffffff24;
  }
  .app-items-container {
    image-rendering: pixelated;
    flex-shrink: 0;
    fill: rgb(0, 0, 0);
    color: rgb(0, 0, 0);
  }
  .app-item-icon {
    width: 48px;
    height: 48px;
    color: #808080;
    display: flex;
    align-items: center;
    justify-content: center;
    fill: #808080;
    > svg {
      width: 40px;
      height: 40px;
      color: #808080;
      fill: #808080;
    }
  }
`;
